const ARLES = [
    {
      page: 3,
      lib: "Première énigme !",
      texteIndice: ["Comparez lettres & chiffres", "Choisissez les lettres en fonction de la date", "HUMILITE"]
    },
    {
      page: 5,
      lib: "A bien voir...",
      texteIndice: ["Dans l'ordre chronologique", "Gardez les lettres de l'étoile", "DERNIER"]
    },
    {
      page: 8,
      lib: "Le mouton",
      texteIndice: [
        "Regardez l'église",
        "Levez les yeux",
        "GARGOUILLE(S)"
      ]
    },
    {
      page: 10,
      lib: "Témoignages",
      texteIndice: [
        "Un problème d'étages...",
        "Un problème de direction...",
        "La lettre 'Q'"
      ]
    },
    {
      page: 15,
      lib: "Le souvenir",
      texteIndice: ["Déjà lu", "Gravé en hauteur à droit juste avant de retourner dans la rue","GRILLON"]
    },
    {
      page: 17,
      lib: "Les visages",
      texteIndice: ["Gardez les bonnes horloges selon le texte", "Ne gardez que les lettres en gras des bonnes horloges", "CHAPARDE"]
    },
    {
      page: 20,
      lib: "Les points cardinaux",
      texteIndice: ["Utilisez la plaque", "L'est = 'E'", "NEON"]
    },
    {
      page: 22,
      lib: "Remontez dans le temps",
      texteIndice: ["Vous avez déjà vu ces symboles", "Dans les pages précédentes", "NUIT"]
    },
    {
      page: 24,
      lib: "Le Chimpnuk US",
      texteIndice: ["A l'heure US", "23h = 11h pm", "AUBE"]
    },
    {
      page: 25,
      lib: "La grille",
      texteIndice: ["Le gras est un indice", "Trouvez le cadenas sur la grille, retirez 1 au chiffre", "11 (-1)"]
    },
    {
      page: 28,
      lib: "Mots croisés",
      texteIndice: ["3: Mistral", "1: Caldarium", "AUTO"]
    },
    {
      page: 30,
      lib: "Assemblage",
      texteIndice: ["Utilisez un outil", "Les horaires dessinent des lettres", "VIE"]
    },
    {
      page: 32,
      lib: "Ying Yang",
      texteIndice: ["Les contraires", "Les opposés", "SOMMEIL"]
    },
    {
      page: 34,
      lib: "La place du forum",
      texteIndice: ["Comparez avec la façade", "Remettez dans l'ordre", "CONTINUEZ VOTRE CHEMIN"]
    },
    {
      page: 36,
      lib: "La clé de l'énigme",
      texteIndice: ["Des clés bizarres", "En forme de toitures", "REVER"]
    },
    {
      page: 37,
      lib: "L'horloge anglaise",
      texteIndice: ["Le cadran solaire, traduisez en anglais", "Il manque des chiffres", "BLACK"]
    },
    {
      page: 38,
      lib: "Dernière énigme !",
      lib_page: "Dernière étape - Vérifier la réponse à toute l'enquête !",
      texteIndice: ["Si je vis, je dévore tout ici,", "quand je bois, je meurs", "LE FEU"]
    }
  ];


export default ARLES;